import React from "react";
import { Routes, Route } from "react-router-dom";
import ListLead from "../Components/Leads/listLead";
import AddLead from "../Components/Leads/addLead";
import ViewLead from "../Components/Leads/viewLead";
import EditLead from "../Components/Leads/editLead";
import AddAppointment from "../Components/Leads/createAppointment";

const LeadRoutes = () => {
  return (
    <Routes>
      <Route
        path="/leads"
        element={<ListLead />}
      />
      <Route
        path="/leads/add"
        element={<AddLead />}
      />
      <Route
        path="/leads/edit/:id"
        element={<EditLead />}
      />
      <Route
        path="/leads/view/:id"
        element={<ViewLead />}
      />
      <Route
        path="/leads/create_appointment/:id"
        element={<AddAppointment />}
      />
    </Routes>
  );
};

export default LeadRoutes;